import { Message } from '@mypaas/honeycomb-ui'

export default Vue => {
    const OFFSET = 54
    //定义一个新的Message方法，多传入一个offset参数
    const $message = options => Message({
        ...options,
        offset: OFFSET,
    });

    //重写一遍success的方法,将offset写入options
    ['success', 'warning', 'info', 'error'].forEach(type => {
        $message[type] = options => {
            if (typeof options === 'string') {
                options = {
                    message: options,
                }
            }
            options = {
                ...options,
                type,
            }
            return Message({ ...options, offset: OFFSET })
        }
    })
    //将$message挂载到this上
    Vue.prototype.$message = $message
}
